import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { Config } from '../../helper';

export default function OpenSearchClearAllFiltersButton() {
  const {clearFilters, filters} = useSearch();

  if (!filters.length) return null;

  return (
    <button className='clear-filters p--medium' onClick={() => clearFilters()}>
      {Config.I18n.Filters.ClearAll}
    </button>
  );
}
